import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RankerComplexShortcutCard.css';

function RankerComplexShortcutCard() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="ranker-shortcut-card"
      onClick={() => navigate('/ranking')}
    >
      <div className="ranker-shortcut-card__title-row">
        <span className="ranker-shortcut-card__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" className="ranker-shortcut-card__icon-svg">
            <path d="M4 21V10.5L12 4l8 6.5V21h-5.2v-5.6H9.2V21H4z" fill="currentColor" />
          </svg>
        </span>
        <div className="ranker-shortcut-card__title">랭커단지</div>
      </div>
      <p className="ranker-shortcut-card__desc">허위데이터를 배제하여 정제된 랭커 단지를 확인해보세요.</p>
      <span className="ranker-shortcut-card__cta">단지 보러가기</span>
    </button>
  );
}

export default RankerComplexShortcutCard;
